import { createApp } from "vue";
import App from "./App.vue";

import { createWebHistory, createRouter } from "vue-router";

import Home from "./page/Home.vue";
import About from "./page/About.vue";
import Assessment from "./page/Assessment.vue";
import Support from "./page/Support.vue";
import Costs from "./page/Costs.vue";
import FAQs from "./page/FAQs.vue";
import reveal from "./directives/reveal";

const routes = [
  { path: "/", component: Home },
  { path: "/about", component: About },
  { path: "/assessment", component: Assessment },
  { path: "/support", component: Support },
  { path: "/costs", component: Costs },
  { path: "/faqs", component: FAQs },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    const position = savedPosition || (to.hash ? { el: to.hash } : { top: 0 });
    if (to.path === from.path) return position;

    // Wait for the outgoing page to fade out before moving the scroll position
    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    return new Promise((resolve) => {
      setTimeout(() => resolve(position), reducedMotion ? 0 : 200);
    });
  },
});

createApp(App).use(router).directive("reveal", reveal).mount("#app");
